__turbopack_context__.v({
  "activeDot": "TeamCarousel-module__hkNhFq__activeDot",
  "arrowThumbLeft": "TeamCarousel-module__hkNhFq__arrowThumbLeft",
  "arrowThumbRight": "TeamCarousel-module__hkNhFq__arrowThumbRight",
  "clientImage": "TeamCarousel-module__hkNhFq__clientImage",
  "customDot": "TeamCarousel-module__hkNhFq__customDot",
  "memberRole": "TeamCarousel-module__hkNhFq__memberRole",
  "slick-next": "TeamCarousel-module__hkNhFq__slick-next",
  "slick-prev": "TeamCarousel-module__hkNhFq__slick-prev",
  "slickThumbs": "TeamCarousel-module__hkNhFq__slickThumbs",
  "teamCard": "TeamCarousel-module__hkNhFq__teamCard",
  "teamCarouselContainer": "TeamCarousel-module__hkNhFq__teamCarouselContainer",
  "teamImage": "TeamCarousel-module__hkNhFq__teamImage",
  "testimonialContent": "TeamCarousel-module__hkNhFq__testimonialContent",
  "testimonialText": "TeamCarousel-module__hkNhFq__testimonialText",
  "thumbnailScroller": "TeamCarousel-module__hkNhFq__thumbnailScroller",
  "thumbnailWrapper": "TeamCarousel-module__hkNhFq__thumbnailWrapper",
});
